import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col px-12px py-12px justify-start overflow-auto" }
const _hoisted_2 = {
  class: "masonry",
  ref: "gridRef"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }

import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'myUpload',
  props: {
  id: {
    type: String,
    default: ''
  }
},
  setup(__props, { expose: __expose }) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = __props
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})

const resourceList = ref([])
const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 2, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

__expose({ getList })

// 移除基于 grid 行高的测量逻辑，改用 CSS columns 布局



onMounted(() => {


})


const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "masonry-item cursor-pointer"
        }, [
          _createElementVNode("div", {
            class: "masonry-content",
            onClick: ($event: any) => (handleClick(item))
          }, [
            _createElementVNode("img", {
              src: item.full_preview_url,
              alt: "",
              class: "media"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ], 512),
    (resourceList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})